import ValidationMethod from './ValidationMethod';

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const email = ({ errorMessage = '' } = {}): ValidationMethod => (v) => !v || emailRegex.test(v) || errorMessage;

export { email };
export default email;
